"use strict";
/*FOR DNN IMPLEMENTATIONS - REQUIRES JQUERY*/

// $('iframe[src*="youtube.com"], iframe[src*="player.vimeo.com"]').each(function () {
//   if (!$('body').hasClass('dnnEditState')) {
//     iframe = $(this);
//     height = iframe.height();
//     width = iframe.width();
//     ratio = ((height / width) * 100);
//     padding = ratio.toFixed(2) + '%';
//     var hasClass = $(this).attr('class');
//     var hasAlign = $(this).attr('align');
//     if (typeof hasClass !== typeof undefined && hasClass !== false) {
//       if (hasClass == 'alignleft') {
//         iframe.wrap('<div class="flex-container alignleft"><div class="flex-video" style="padding-bottom:' + padding + '"></div></div>');
//       } else if (hasClass == 'alignright') {
//         iframe.wrap('<div class="flex-container alignright"><div class="flex-video" style="padding-bottom:' + padding + '"></div></div>');
//       } else if (hasClass == 'aligncenter') {
//         iframe.wrap('<div class="flex-container aligncenter"><div class="flex-video" style="padding-bottom:' + padding + '"></div></div>');
//       } else {
//         iframe.wrap('<div class="flex-video" style="padding-bottom:' + padding + '"></div>');
//       }
//     } else if (typeof hasAlign !== typeof undefined && hasAlign !== false) {
//       if (hasAlign == 'left') {
//         iframe.wrap('<div class="flex-container alignleft"><div class="flex-video" style="padding-bottom:' + padding + '"></div></div>');
//       } else if (hasAlign == 'right') {
//         iframe.wrap('<div class="flex-container alignright"><div class="flex-video" style="padding-bottom:' + padding + '"></div></div>');
//       } else if (hasAlign == 'center') {
//         iframe.wrap('<div class="flex-container aligncenter"><div class="flex-video" style="padding-bottom:' + padding + '"></div></div>');
//       } else {
//         iframe.wrap('<div class="flex-video" style="padding-bottom:' + padding + '"></div>');
//       }
//     } else {
//       iframe.wrap('<div class="flex-video" style="padding-bottom:' + padding + '"></div>');
//     }
//   }
// });

document.addEventListener("DOMContentLoaded", function () {
  Object.prototype.responsivevideos = function () {
    // in your main.js, homepage.js or subpage.js use $('SELECTORS').responsivevideos(); to specify which containers should be searched for videos to make responsive
    // with class: {{video=http://vimeo.com/25451551}}
    // without class: {{video=https://www.youtube.com/watch?v=r11wAaOLhgo left|center|right}}
    const container = document.getElementsByTagName('main')[0];

    //Regex to match all video embeds in content
    let videoMatch = /{{video=(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)?(?:\s+)?([a-zA-Z]+)?}}/g;

    if (container.textContent.match(videoMatch)) {

      let videos = container.textContent.match(videoMatch);

      videos.forEach((vid) => {
        let video = videoMatch.exec(vid);
        let videoitem = vid.toString();
        let videoArray = videoitem.split(' ');
        let url = videoArray[0].substring(8);
        let type = videoArray[0].substring(videoArray[0].indexOf("www") + 4, videoArray[0].indexOf(".com"));
        let id = '';
        let align = '';
        let videoReplaced = '';

        if (vid[7] != null) {
          align = 'align' + videoArray[1].substring(0, videoArray[1].indexOf("}}"));
        }

        if (type === 'youtube') {
          id = videoArray[0].substring(vid.indexOf("?v=") + 3);
          videoReplaced = document.getElementsByTagName('main')[0].innerHTML.replace(videoMatch, `<div class="flex-container ${align}">
                             <div class="flex-video">
                               <iframe src="https://www.youtube.com/embed/${id}?autoplay=0&modestbranding=1&rel=0" frameBorder="0" title="" aria-hidden="true"/>
                             </div>
                           </div>`);
        } else if (type === 'vimeo') {
          id = videoArray[0].substring(vid.indexOf(".com/") + 5);
          videoReplaced = document.getElementsByTagName('main')[0].innerHTML.replace(videoMatch, `<div class="flex-container ${align}">
                             <div class="flex-video">
                               <iframe src="https://player.vimeo.com/video/${id}" frameBorder="0" title="" aria-hidden="true"/>
                             </div>
                           </div>`);
        }
        //document.getElementsByTagName('main')[0].innerHTML = videoReplaced;
      });
    }
  };

  document.getElementsByTagName('main')[0].responsivevideos();

  document.querySelectorAll('iframe.responsive-video').forEach((vid) => {
    let responsiveVideo = vid.getAttribute('src');
    vid.insertAdjacentHTML('afterend', `<div class="flex-container">
                                          <div class="flex-video">
                                            <iframe src="${responsiveVideo}" frameBorder="0" title="" aria-hidden="true"/>
                                          </div>
                                        </div>`);
    vid.remove();
  });
});